import React, { useState } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from './ui/command';
import { COUNTRIES } from '../lib/countries';

// Searchable country picker; `style` matches the surrounding form inputs.
export const CountrySelect = ({ value, onChange, style, testId = 'country-select' }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} aria-required="true" data-testid={testId}
          style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign: 'left', cursor: 'pointer', color: value ? '#002A38' : '#94A3B8' }}>
          <span>{value || 'Select country'}</span>
          <ChevronDown size={16} color="#94A3B8" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[240px]" align="start">
        <Command filter={(value, search) => (value.toLowerCase().includes(search.trim().toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Search country…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-60">
            <CommandEmpty>No country found.</CommandEmpty>
            {COUNTRIES.map((c) => (
              <CommandItem key={c} value={c} onSelect={() => { onChange(c); setOpen(false); }}
                data-testid={`${testId}-option-${c.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
                <Check size={14} style={{ marginRight: 8, opacity: value === c ? 1 : 0 }} />
                {c}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
